var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fill-height column-format" },
    [
      _c("h-header"),
      _c(
        "div",
        { staticClass: "agreement-list portal-compact-list-shell" },
        [
          _c("v-data-table", {
            staticClass: "pointer portal-compact-table",
            attrs: {
              items: _vm.filteredProposalList,
              headers: _vm.headers,
              "hide-default-footer": true,
              "disable-pagination": true,
              "mobile-breakpoint": 200,
              "fixed-header": ""
            },
            on: { "click:row": _vm.openAgreement },
            scopedSlots: _vm._u([
              {
                key: "item.name",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "portal-cell-truncate portal-cell-primary",
                        attrs: { title: item.name }
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  ]
                }
              },
              {
                key: "item.date",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "portal-cell-truncate portal-cell-muted",
                        attrs: {
                          title: _vm.DateTime.fromISO(item.date).toLocaleString(
                            _vm.DateTime.DATE_MED
                          )
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.DateTime.fromISO(item.date).toLocaleString(
                                _vm.DateTime.DATE_MED
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.dateCompleted",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.dateCompleted
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "portal-cell-truncate portal-cell-muted",
                            attrs: {
                              title: _vm.DateTime.fromISO(
                                item.dateCompleted
                              ).toLocaleString(_vm.DateTime.DATE_MED)
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.DateTime.fromISO(
                                    item.dateCompleted
                                  ).toLocaleString(_vm.DateTime.DATE_MED)
                                ) +
                                " "
                            )
                          ]
                        )
                      : _c("span", { staticClass: "portal-cell-muted" }, [
                          _vm._v("—")
                        ])
                  ]
                }
              },
              {
                key: "item.status",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "portal-status-pill",
                      {
                        attrs: {
                          color:
                            "var(" + _vm.statusDetail(item.status).color + ")",
                          background:
                            "var(" +
                            _vm.statusDetail(item.status).background +
                            ")"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.statusDetail(item.status).label) +
                            " "
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "no-data",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "agreement-empty" },
                      [
                        _c("portal-icon", {
                          attrs: { name: "handshake", size: 28 }
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("proposals.no-agreements")))
                        ])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }